import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
// import Grid from '@material-ui/core/Grid'
import GridList from '@material-ui/core/GridList'
import GridListTile from '@material-ui/core/GridListTile'
import GridListTileBar from '@material-ui/core/GridListTileBar'
import { selectEmailCard } from 'actions/template'
import styles from './styles'
import language from 'utils/vast-languagepack'
import { stepperIncrease } from 'actions/view'
import { receiveTemplate, selectTemplateType } from '../../actions/template'
import { withRouter } from 'react-router-dom'
const TemplateForm_Cards = ({
  selectEmailCard,
  classes,
  cols,
  taskForm,
  stepperIncrease,
  sectionsLength,
  receiveTemplate,
  modal,
  selectedActionPrediction,
  selectTemplateType,
  history,
  match,
}) => {
  return (
    <div
      className={
        modal
          ? classes.templateFormCardsModal
          : taskForm
          ? classes.templateFormCardsTask
          : classes.templateFormCards
      }
    >
      <GridList
        cellHeight={300}
        cols={taskForm ? (selectedActionPrediction === 'email' ? 3 : 2) : 3}
        spacing={12}
      >
        {(!taskForm || selectedActionPrediction !== 'sms') && (
          <GridListTile
            classes={{ tile: classes.tile }}
            className={classes.gridListTile}
            onClick={() => {
              if (
                taskForm ||
                match?.params?.templateId === 'new' ||
                match?.params?.templateType === 'email'
              ) {
                if (sectionsLength) {
                  if (
                    window.confirm(
                      'This will replace all content currently in your editor. Are you sure?',
                    )
                  ) {
                    Promise.resolve(receiveTemplate('new')).then(() => {
                      if (!taskForm) {
                        history.replace(
                          `/templates/email/${match?.params?.templateId}`,
                        )
                      }
                      selectTemplateType('email')
                      stepperIncrease('task')
                      stepperIncrease('template')
                      selectEmailCard('blank')
                    })
                  }
                } else {
                  Promise.resolve(receiveTemplate('new')).then(() => {
                    if (!taskForm) {
                      history.replace(
                        `/templates/email/${match?.params?.templateId}`,
                      )
                    }
                    selectTemplateType('email')
                    stepperIncrease('task')
                    stepperIncrease('template')
                    selectEmailCard('blank')
                  })
                }
              }
            }}
          >
            <img src="/plus.svg" alt="new" height="180px" />
            <GridListTileBar
              title={language.task.add.blank}
              subtitle={
                <span>
                  {!taskForm &&
                  match?.params?.templateId !== 'new' &&
                  match?.params?.templateType !== 'email'
                    ? 'This is disabled'
                    : language.task.add.createBlank}
                </span>
              }
            />
          </GridListTile>
        )}
        {(!taskForm || selectedActionPrediction === 'sms') && (
          <GridListTile
            className={classes.gridListTile}
            classes={{ tile: classes.tile }}
            onClick={() => {
              if (
                taskForm ||
                match?.params?.templateId === 'new' ||
                match?.params?.templateType === 'sms'
              ) {
                selectTemplateType('sms')
                if (!taskForm) {
                  history.replace(`/templates/sms/${match?.params?.templateId}`)
                }
                stepperIncrease('task')
                stepperIncrease('template')
                selectEmailCard('sms')
              }
            }}
          >
            <img src="/sms.svg" alt="themes" height="180px" />
            <GridListTileBar
              title={
                taskForm ? 'New Text Message' : 'New Text Message Template'
              }
              subtitle={
                <span>
                  {!taskForm &&
                  match?.params?.templateId !== 'new' &&
                  match?.params?.templateType !== 'sms'
                    ? 'This is disabled'
                    : `Create a new text message ${taskForm ? '' : 'template'}`}
                </span>
              }
            />
          </GridListTile>
        )}
        {(!taskForm || selectedActionPrediction === 'email') && (
          <GridListTile
            className={classes.gridListTile}
            classes={{ tile: classes.tile }}
            onClick={() => {
              if (
                taskForm ||
                match?.params?.templateId === 'new' ||
                match?.params?.templateType === 'email'
              ) {
                if (!taskForm) {
                  history.replace(
                    `/templates/email/${match?.params?.templateId}`,
                  )
                }
                selectTemplateType('email')
                selectEmailCard('themes')
              }
            }}
          >
            <img src="/format-color-fill.svg" alt="themes" height="180px" />
            <GridListTileBar
              title="Email Themes"
              subtitle={
                <span>
                  {match?.params?.templateId !== 'new' &&
                  match?.params?.templateType !== 'email'
                    ? 'This is disabled'
                    : language.task.add.createThemes}
                </span>
              }
            />
          </GridListTile>
        )}
        {taskForm ? (
          <GridListTile
            classes={{ tile: classes.tile }}
            className={classes.gridListTile}
            onClick={() => {
              if (selectedActionPrediction === 'sms') {
                selectEmailCard('smsTemplates')
              } else {
                selectEmailCard('templates')
              }
              // stepperIncrease('task')
            }}
          >
            <img src="/file-document.svg" alt="templates" height="180px" />
            <GridListTileBar
              title={language.task.add.templates}
              subtitle={<span>{language.task.add.templatesCreate}</span>}
            />
          </GridListTile>
        ) : null}
      </GridList>
    </div>
  )
}
export default withRouter(
  connect(
    state => ({
      sectionsLength: Boolean(state.email.sections.length),
      selectedActionPrediction:
        state.tasks.addOrEdit?.fields?.selectedActionPrediction?.value,
    }),
    dispatch =>
      bindActionCreators(
        {
          selectEmailCard,
          stepperIncrease,
          receiveTemplate,
          selectTemplateType,
        },
        dispatch,
      ),
  )(withStyles(styles)(TemplateForm_Cards)),
)
